import React from 'react'
import styles from './styles'
import { withStyles } from '@material-ui/core'
import {
  CustomDomainHeader,
  InviteSection,
  CollaboratorList,
} from './components'
import { useSelector } from 'react-redux'
import UpgradeCollaborationBanner from 'src/components/upgrade-collaboration'
import UserType from 'src/model/user-types'
const Collaboration = props => {
  const { classes } = props
  const user = useSelector(state => state.authentication.me)
  const hasAccess = UserType.hasCollaboration(
    user?.userRoleId ?? window.CONSTANTS.USER_ROLE_ID,
  )
  return (
    <div className={classes.root}>
      <CustomDomainHeader />
      {hasAccess ? (
        <>
          <InviteSection />
          <CollaboratorList />
        </>
      ) : (
        <UpgradeCollaborationBanner />
      )}
    </div>
  )
}

export default withStyles(styles)(Collaboration)
